import type {
    IndexUserNotificationReturnType,
    PopulatedUserNotification,
} from '@/apis/lib/user-notification';
import { getIndexUrl } from '@/apis/lib/user-notification';
import { useCallback, useState } from 'react';
import _ from 'lodash';
import useFetchAPI from '@/apis/useFetch';

export interface AggregatedUserNotification {
    topics: string[];
    aggregatedData: _.Dictionary<PopulatedUserNotification[]>;
}

const _aggregateNotificationData = (data?: PopulatedUserNotification[]) => {
    const aggregatedData = _.groupBy(data, datum => {
        return datum.Notification?.locale;
    });
    const topics = Object.keys(aggregatedData);

    return {
        topics,
        aggregatedData,
    };
};

const useCurrentMemberNotification = () => {
    /* Jangan pakai findBy-exclude: notifikasi survei_request (survei_request_client = My Request Survey, survei_request_professional = Request Survey Order) harus ikut di-index agar total di bell bertambah */
    const [refetchKey, setRefetchKey] = useState(0);
    const indexCurrentMemberNotificationUrl = getIndexUrl({
        sortBy: 'createdAt',
        sortOrientation: 'DESC',
        /* Cache-bust saat refetch saja agar data terbaru (termasuk survei_request_client) ikut ke bell */
        ...(refetchKey > 0 ? { _: refetchKey } : {}),
    });

    const { data, loading, error } = useFetchAPI<IndexUserNotificationReturnType>(
        indexCurrentMemberNotificationUrl
    );

    const refetch = useCallback(() => {
        setRefetchKey(k => k + 1);
    }, []);

    let _aggregatedNotificationData: AggregatedUserNotification = {
        topics: [],
        aggregatedData: [] as unknown as _.Dictionary<PopulatedUserNotification[]>,
    };

    if (!loading && !error) {
        _aggregatedNotificationData = _aggregateNotificationData(data?.data);
        /* Log notification data for debugging */
        if (data?.data) {
            console.log('[useCurrentMemberNotification] Notification data received:', {
                count: data.data.length,
                notifications: data.data.map((n: any) => ({
                    id: n.id,
                    locale: n.Notification?.locale,
                    acked: n.acked,
                })),
            });
        }
    }

    return {
        loading,
        error,
        rawData: data?.data,
        data: _aggregatedNotificationData,
        refetch,
    };
};

export default useCurrentMemberNotification;
